const ContactPage = () => (
  <div className="min-h-screen pt-24">
    <section className="relative py-20 bg-gradient-to-br from-yellow-100 via-blue-100 to-pink-100">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <span className="inline-block px-6 py-2 bg-gradient-to-r from-blue-500 to-green-500 text-white rounded-full text-sm font-bold uppercase tracking-wide mb-6">
          İletişime Geçin
        </span>
        <h1 className="text-6xl font-black text-gray-900 mb-6">
          Bizimle{" "}
          <span className="bg-gradient-to-r from-pink-500 to-orange-500 bg-clip-text text-transparent">
            İletişime Geçin
          </span>
        </h1>
        <p className="text-xl text-gray-600">
          Sorularınız için bize ulaşın, size yardımcı olmaktan mutluluk duyarız!
        </p>
      </div>
    </section>

    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12">
          <div className="space-y-6">
            <h2 className="text-4xl font-black text-gray-900 mb-8">
              İletişim Bilgileri
            </h2>

            {[
              {
                icon: "📍",
                title: "Adres",
                info: "Şehitlik, Boztepe Cd. NO:52, 06900 \nPolatlı/Ankara",
              },
              { icon: "📞", title: "Telefon", info: "+90 533 449 90 39" },
              {
                icon: "✉️",
                title: "E-posta",
                info: "littlewinners06@gmail.com",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-gray-50 p-6 rounded-2xl flex gap-4 hover:translate-x-2 transition-all"
              >
                <div className="text-4xl">{item.icon}</div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 whitespace-pre-line">
                    {item.info}
                  </p>
                </div>
              </div>
            ))}

            <div className="bg-gray-50 p-6 rounded-2xl">
              <h3 className="font-bold text-xl text-gray-900 mb-4">
                Sosyal Medya
              </h3>
              <div className="flex gap-4">
                <a
                  href="https://instagram.com/littlewinners06"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:-translate-y-1 transition-all"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="w-6 h-6"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10z" />
                    <path d="M12 7a5 5 0 100 10 5 5 0 000-10zm0 2.2a2.8 2.8 0 110 5.6 2.8 2.8 0 010-5.6z" />
                    <circle cx="17.5" cy="6.5" r="0.8" />
                  </svg>
                </a>

                <a
                  href="https://wa.me/905334499039"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:-translate-y-1 transition-all"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="w-6 h-6"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M20.52 3.48A11.88 11.88 0 0012 .25 11.9 11.9 0 003.48 3.48C1.42 6.54 1 10.63 2.33 14.31L2 21l6.9-.33c3.68 1.32 7.77.9 10.83-1.16A11.9 11.9 0 0024 12c0-1.92-.44-3.84-1.48-5.52zM12 21c-1.18 0-2.36-.14-3.47-.42l-.25-.07-4.12.2.43-3.97-.11-.27A8.01 8.01 0 014 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 3.69-2.57 6.82-6 7.68A7.9 7.9 0 0112 21z" />
                    <path d="M17.56 14.86c-.28-.14-1.66-.82-1.92-.91-.26-.09-.45-.14-.64.14-.18.28-.7.91-.86 1.1-.15.18-.3.2-.58.07-.28-.14-1.18-.43-2.25-1.39-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.12-.12.28-.31.42-.47.14-.16.18-.28.28-.47.09-.18.05-.35-.02-.49-.07-.14-.64-1.54-.88-2.11-.23-.56-.47-.48-.64-.49l-.55-.01c-.18 0-.47.07-.72.34-.25.28-.95.93-.95 2.27 0 1.34.98 2.64 1.12 2.82.14.18 1.93 3.04 4.68 4.26 3.25 1.44 3.25 0 3.84-.05.6-.06 1.9-.77 2.17-1.51.28-.75.28-1.39.2-1.51-.07-.12-.26-.18-.54-.32z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-3xl shadow-lg">
            <h2 className="text-3xl font-black text-gray-900 text-center mb-6">
              Konumumuz
            </h2>
            <div className="aspect-[16/9] w-full rounded-xl overflow-hidden shadow-inner">
              <iframe
                title="Little Winners Konum"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3075.134944416766!2d32.108837075969696!3d39.57910897158655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMznCsDM0JzQ0LjgiTiAzMsKwMDYnNDEuMSJF!5e0!3m2!1str!2str!4v1763473043536!5m2!1str!2str"
                className="w-full h-full border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="mt-6 space-y-6">
              <div className="bg-gray-50 p-6 rounded-2xl">
                <h3 className="font-bold text-xl text-gray-900 mb-4">
                  Çalışma Saatleri
                </h3>
                <div className="space-y-3">
                  {[
                    { day: "Salı - Pazar", time: "11:00 - 21:30" },
                    { day: "Pazartesi", time: "Kapalı" },
                  ].map((hour, index) => (
                    <div
                      key={index}
                      className="flex justify-between items-center p-3 bg-white rounded-lg"
                    >
                      <span className="font-semibold text-gray-900">
                        {hour.day}
                      </span>
                      <span className="font-bold text-pink-500">
                        {hour.time}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
);
export default ContactPage;
